<div class="bg-ponder-dark min-h-screen w-full overflow-x-hidden flex flex-col"  style="background: linear-gradient(#343346, #1A1922);">
    <div class="flex flex-col gap-4 p-8 pt-12 pb-12 justify-center">
        <div class="flex justify-center">
            <div class="pt-12 max-w-sm sm:max-w-3xl xl:max-w-5xl grow text-xl sm:text-2xl font-bold font-title text-white text-center">
                Create a <span class="text-foil">Ponder</span> Account
            </div>
        </div>
        <div class="flex justify-center">
            <div class="text-faded-70 p-2 rounded bg-red-900 shadow text-sm sm:text-base">Account creation is disabled. <a href="/news?id=068016ee-423c-7a56-8000-894dda165ab4" class="text-faded-90 hover:text-white">Read more here.</a></div>
        </div>
        <div class="flex justify-center">
            <form [formGroup]="signupForm" (submit)="onSubmit()" class="flex flex-col p-4 gap-3 w-[360px] text-base">
                <!-- Email -->
                <div class="flex flex-col gap-1">
                    <input 
                        formControlName="email" 
                        (blur)="onEmailLoseFocus()" 
                        type="email" 
                        placeholder="Email" 
                        class="bg-ponder rounded-sm shadow-sm p-2 w-full text-white border disabled:text-faded-50" 
                        [ngClass]="{ 'border-red-600' : emailError, 'border-transparent' : !emailError }"
                        autocomplete="email"/>
                    
                    @if (emailError) {
                        <div class="text-xs text-red-600">{{ emailError }}</div>
                    }
                </div>
                <!-- Username -->
                <div class="flex flex-col gap-1">
                    <input formControlName="username" 
                        type="text" 
                        (blur)="onUsernameLoseFocus()" 
                        placeholder="Username"
                        class="bg-ponder rounded-sm shadow-sm p-2 w-full text-white border disabled:text-faded-50"
                        [ngClass]="{ 'border-red-600' : usernameError, 'border-transparent' : !usernameError }"
                        autocomplete="username"/>
                    @if (usernameError) {
                        <div class="text-xs text-red-600">{{ usernameError }}</div>
                    }
                </div>
                <!-- Password -->
                <div class="flex flex-col gap-1">
                    <input 
                        formControlName="password" 
                        (blur)="onPasswordLoseFocus()" 
                        type="password" 
                        placeholder="Password"
                        class="bg-ponder rounded-sm shadow-sm p-2 w-full text-white border disabled:text-faded-50" 
                        [ngClass]="{ 'border-red-600' : passwordError, 'border-transparent' : !passwordError}"
                        autocomplete="new-password">
                    @if (passwordError) {
                        <div class="text-xs text-red-600">{{ passwordError }}</div>
                    }
                </div>
                <!-- Submit -->
                <button 
                    class="bg-ponder hover:bg-ponder-xlight rounded-sm shadow-sm p-2 w-full min-h-[40px] text-slate-200 hover:text-white disabled:text-faded-50 hover:disabled:bg-ponder"
                    [disabled]="!canSubmit()">
                    @if (!isProcessing) {
                        Create Account
                    } @else {
                        <busy-spin [small]="true" [bright]="true"></busy-spin>
                    }
                </button>
                <!-- Messages -->
                @if (processingError) {
                    <div class="p-1 text-xs text-red-600 border-red-600 border rounded">
                        {{ processingError }}
                    </div>
                }
                <div class="text-xs text-right text-faded-40">
                    Have an account? <a href="/login" class="text-faded-60 hover:text-faded-80">Login now</a>
                </div>
                <div class="text-xs text-faded-20 pt-4">
                    By clicking "Create Account" you agree to our <a href="/terms" class="text-faded-40 hover:text-faded-60">Terms of Service</a>
                </div>
            </form>
        </div>
    </div>
</div>
<overauthorized></overauthorized>